// Line definitions — API-backed (electric lines, gas/liquid pipelines)
const API = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5001`;

const authHeaders = () => {
  const token = localStorage.getItem('nrg-token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };
};

export async function loadLineDefinitions() {
  try {
    const res = await fetch(`${API}/api/line-definitions`, { headers: authHeaders() });
    if (!res.ok) return [];
    return await res.json();
  } catch {
    return [];
  }
}

export async function saveLineDefinition(def) {
  const { id, category, name } = def;
  const res = await fetch(`${API}/api/line-definitions/${id}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify({ ...def, id, category, name }),
  });
  return res.ok;
}

export async function createLineDefinition(def) {
  const res = await fetch(`${API}/api/line-definitions`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(def),
  });
  return res.ok;
}

export async function deleteLineDefinition(id) {
  const res = await fetch(`${API}/api/line-definitions/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  return res.ok;
}

// Calculate line loss at a given load fraction
export function calculateLineLoss(def, loadFraction, lengthKm) {
  const len = lengthKm || 1;
  const rTotal = (def.r_ohm_per_km || 0) * len;
  const lossPctPerKm = def.loss_pct_per_km || 0;
  const totalLoss = lossPctPerKm * len * Math.pow(loadFraction, 2);
  return {
    r_total: rTotal,
    loss_pct: totalLoss,
    formula: `${lossPctPerKm}% × ${len}km × (I/I_rated)²`,
  };
}

// PyPSA Line parameters
export function lineToPyPSA(def) {
  return {
    type: def.lineType === 'underground' ? 'Cable' : 'Line',
    v_nom: def.voltage_kv,
    r: def.r_ohm_per_km,
    x: def.x_ohm_per_km,
    b: (def.b_us_per_km || 0) * 1e-6,
    s_nom: def.s_max_mva || null,
    length: null, // per instance
  };
}
